import Mmenu from 'mmenu-js';
import 'mmenu-js/dist/mmenu.css';

document.querySelectorAll('.header-menu .menu-item__icon').forEach(item => item.addEventListener('click', function () {
    const parent_el = item.closest('.menu-item');
    parent_el.classList.toggle('active');
}));

document.querySelectorAll('.mega-menu-block__backdrop').forEach(item => item.addEventListener('click', function () {
    const parent_el = item.closest('.menu-item');
    parent_el.classList.remove('active');
}));

if (document.querySelector('.header-mobile-menu__wrapper')) {
    const menu_mob = new Mmenu( ".header-mobile-menu__wrapper", {
        slidingSubmenus: true,
        offCanvas: {
            position: "left",
        },
        page: {
            selector: "#app"
        },
        theme: "white-contrast",
        navbars: [
            {
                content: ['prev'],
                position: "top",
            }
        ]
    });

    const api_mmenu = menu_mob.API;
    const menu_toggle_btn = document.querySelector(".header__button");


    menu_toggle_btn.addEventListener("click", () => {
        if (document.body.classList.contains("mm-wrapper--opened")) {
            api_mmenu.close();
        } else {
            api_mmenu.open();
        }
    });

    api_mmenu.bind("open:after", () => {
        menu_toggle_btn.classList.add("is-active");
    });
    api_mmenu.bind("close:after", () => {
        menu_toggle_btn.classList.remove("is-active");
    });
}

if (document.querySelector('.header--fixed') && document.querySelector('.hero-home')) {
    let lastScroll = 0;
    const header = document.querySelector('.header');
    const home_hero_el = document.querySelector('.hero-home');

    window.addEventListener('scroll', () => {
        const currentScroll = window.pageYOffset;

        if (currentScroll > (home_hero_el.offsetHeight - header.offsetHeight)) {
            header.classList.add('header--revert');
        }
        else {
            header.classList.remove('header--revert');
        }

        lastScroll = currentScroll;
    }, {
        passive: true
    });
}